export default __webpack_public_path__ + "static/media/hht2_ep3_speaking_02.c05f12cb.png";